interface CommonsAuEntity {
  entityName: string;
  abn: string;
}

const COMMONS_AU_ENTITY_MAP: Record<string, CommonsAuEntity> = {
  "04b7ce33-a45c-4166-9ad7-75a8f81a6c3e": {
    entityName: "The Commons South Melbourne Pty Ltd",
    abn: "47 612 775 523",
  },
  "08b6803f-8cff-4511-9ea3-19ee17148b47": {
    entityName: "The Commons Collingwood Pty Ltd",
    abn: "45 606 664 000",
  },
  "0fdcccc3-09ac-4ff7-a292-831ef1c6f82a": {
    entityName: "Commons Cremorne Pty Ltd",
    abn: "72 617 416 930",
  },
  "4b14614e-cf58-461a-b8c5-2cb2ba40b071": {
    entityName: "The Commons Central Pty Ltd",
    abn: "43 620 279 334",
  },
  "d4ee819d-82ab-43d5-9a4d-ffd87078ed7a": {
    entityName: "The Commons QV Pty Ltd",
    abn: "45 628 202 326",
  },
  "311176e3-4d46-4aa4-877b-79b076750120": {
    entityName: "The Commons South Yarra Pty Ltd",
    abn: "28 638 666 305",
  },
  "0ba37610-05b1-48a1-aa37-b4f9dc903de2": {
    entityName: "The Commons Surry Hills Pty Ltd",
    abn: "15 650 178 760",
  },
  "0e94c46b-b1b1-4876-82e3-243ddffcab1e": {
    entityName: "The Commons 388 George Pty Ltd",
    abn: "86 651 348 319",
  },
  "172496d2-8d2b-4cbb-a9ab-9d95d2a8f43a": {
    entityName: "The Commons 54 Wellington Pty Ltd",
    abn: "59 653 109 516",
  },
  "0b8513f9-82cd-4bc4-b49a-cbfc9d731365": {
    entityName: "The Commons York St Pty Ltd",
    abn: "87 664 543 677",
  },
  "6942fc82-cdfe-4630-8363-e983cd565874": {
    entityName: "The Commons Cremorne Street Pty Ltd",
    abn: "60 668 795 284",
  },
  "1007c7ce-93c0-45ad-91e0-cf64809e6324": {
    entityName: "The Commons Collins St Pty Ltd",
    abn: "93 669 201 950",
  },
  "260dc154-e97f-4ef6-9bcb-89196cd51075": {
    entityName: "The Commons Castlereagh St Pty Ltd",
    abn: "64 669 201 889",
  },
  "3241e5d0-0b53-4b96-a73f-403dc6c5af26": {
    entityName: "The Commons Martin Place Pty Ltd",
    abn: "39 676 363 376",
  },
  "319598e8-5234-4cde-b2dd-f5da8c1f7945": {
    entityName: "The Commons Toorak Road Pty Ltd",
    abn: "31 678 347 414",
  },
  "1aba98a4-d314-435a-88e7-85589fed2c43": {
    entityName: "Central House",
    abn: "11 068 012 653",
  },
  "1644ab6f-87d7-4844-9efe-5e4073a6f208": {
    entityName: "Central House Toorak",
    abn: "46 905 830 365",
  },
  "1d1c81e6-c00e-480c-9bca-0b61d1c09a46": {
    entityName: "Forum Workspace 65 Dover Pty Ltd",
    abn: "96 670 671 799",
  },
  "0f8f29b1-d657-44ef-b5ca-9d1c61e92423": {
    entityName: "Forum Workspace 383 NSH Pty Ltd",
    abn: "89 686 933 291",
  },
  "1a9b8d33-3a53-45a1-b141-fe1dc7403a1a": {
    entityName: "The Commons Testy Tits Road Pty Ltd",
    abn: "89 686 933 888",
  },
};

export function getCommonsAuEntityData(
  locationId: string | undefined
): CommonsAuEntity | undefined {
  if (!locationId) return undefined;
  return COMMONS_AU_ENTITY_MAP[locationId];
}
